/**
 * プロパティからデータを取得するためのキー
 */
export const PROPERTY_KEYS = {
  /**
   * 国内線ASW(able-D)のURL
   */
  ableDUrl: 'domesticAsw.url',
  /**
   * 国際線ASW(iCAS)チェックイン検索画面のURL
   */
  iCasUrl: 'internationalAsw.url',
} as const;
